// extracted by mini-css-extract-plugin
export var productImage = "_rn-1";
export var viewLink = "_rn-2";
export var wishlistItem = "_rn-0";